const isInsideWorldApp = (): boolean => {
  if (!window) return false
  return !!window.WorldApp;
}

export {
  isInsideWorldApp
}
